import { useParams } from 'react-router-dom';

import { useAssessmentActionsContext } from '~/lib/contexts/AssessmentActionsContext';
import { useGetPatientQuery } from '~/store/services/patients';
import { getPreferredFirstName } from '~/lib/util/patient.util';
import AssessmentsRedesignPage from '~/components/maud/patients/profile/assessments-redesign/AssessmentsRedesignPage';

const AssessmentsPage = () => {
  const { patientId } = useParams<{ patientId: string }>();
  const { data: patient } = useGetPatientQuery(
    { patientId },
    { skip: !patientId },
  );
  const { updateAssessmentState } = useAssessmentActionsContext();

  if (!patientId || !patient) return null;

  const patientPreferredFullName = `${getPreferredFirstName(patient.chosenName, patient.firstName)} ${patient.lastName}`;

  return (
    <AssessmentsRedesignPage
      patient={patient}
      patientId={patientId}
      patientPreferredFullName={patientPreferredFullName}
      updateAssessmentState={updateAssessmentState}
    />
  );
};

export default AssessmentsPage;
